import { EDisplay } from 'components/deal-results/product-items';

export function getActiveIndexForMultiToggleButton(display: EDisplay): number {
  const NETBACK_VALUE = 2;
  const MARGIN_VALUE = 3;

  switch (display) {
    case EDisplay.BASE: {
      return 0;
    }
    case EDisplay.SALES: {
      return 1;
    }
    case EDisplay.NETBACK: {
      return NETBACK_VALUE;
    }
    case EDisplay.MARGIN: {
      return MARGIN_VALUE;
    }
    default: {
      return -1;
    }
  }
}
